import { getPresignedUrlResponse } from '@services/common.services'
import { createContext } from 'react'
import { UploadOptions } from './types'

export default createContext<
  (options: UploadOptions) => Promise<getPresignedUrlResponse> | any
>(() => null)
